// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".link-paper[data-v-8a7ac102]{width:100%;border-top:1px #dfdfdf solid;border-left:1px #dfdfdf solid;margin-bottom:1em;margin:1em 0}.link-paper td[data-v-8a7ac102]{border-right:1px #dfdfdf solid;border-bottom:1px #dfdfdf solid;padding:1em}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
